var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.353,
    height: 32,
    viewBox: "0 0 42.353 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_spreadsheet_353692",
    transform: "translate(-5 -16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10121",
    "data-name": "Group 10121",
    transform: "translate(5 16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8865",
    "data-name": "Path 8865",
    d: "M45,16H7.353A2.356,2.356,0,0,0,5,18.353V45.647A2.356,2.356,0,0,0,7.353,48H45a2.356,2.356,0,0,0,2.353-2.353V18.353A2.356,2.356,0,0,0,45,16ZM7.353,17.882H45a.471.471,0,0,1,.471.471v5.176H6.882V18.353A.471.471,0,0,1,7.353,17.882ZM19.588,38.588V32.941H32.765v5.647Zm13.176,1.882v5.647H19.588V40.471Zm0-15.059v5.647H19.588V25.412ZM17.706,31.059H6.882V25.412H17.706Zm0,1.882v5.647H6.882V32.941Zm16.941,0H45.471v5.647H34.647Zm0-1.882V25.412H45.471v5.647ZM6.882,45.647V40.471H17.706v5.647H7.353A.471.471,0,0,1,6.882,45.647ZM45,46.118H34.647V40.471H45.471v5.176A.471.471,0,0,1,45,46.118Z",
    transform: "translate(-5 -16)",
    fill: "currentColor"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.15313108.svg";
export { ForwardRef as ReactComponent };